export function googleDataToEntities(data) {
  try {
    const res = data.map(i => ({
      address: i.GeoObject.metaDataProperty.GeocoderMetaData.Address.formatted,
      lat: Number(i.GeoObject.Point.pos.split(' ')[1]),
      lng: Number(i.GeoObject.Point.pos.split(' ')[0]),
      locality: i.GeoObject?.metaDataProperty?.GeocoderMetaData.Address?.Components?.find(i => i.kind === 'locality')?.name || '',
    }));
    return res;
  } catch (e) {
    return [];
  }
}
